import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import Cookies from "js-cookie";

// const api = axios.create({
//   //baseURL: "https://your-api.com", // Replace with your backend URL
//   withCredentials: true, // ✅ Automatically send cookies (JWT/session)
// });


let csrf = localStorage.getItem("csrf_token");
let csrfToken = Cookies.get("yii_csrf_token"); // ✅ Retrieve CSRF token from cookie
console.log(csrf,"csrf", )

// axios.interceptors.request.use(function (config) {
//   withCredentials: true,
// })

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

// 🔹 Add Request Interceptor
axios.interceptors.request.use(
  (config) => {
    //config.withCredentials = true; // ✅ Ensure credentials (cookies) are always sent

    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

//  Add a request interceptor
axios.interceptors.request.use(function (config) {

  console.log(document.cookie, "updated cookie")

  let csrf_temp = Cookies.get("yii_csrf_token");

  // Do something before request is sent
  config.withCredentials = true;
  //console.log(config,"axio interceptor");
  //config.headers['Access-Control-Allow-Origin'] = "*";
  config.headers['Authorization'] = "Bearer " + localStorage.getItem('TOKEN');
  config.headers['X-CSRF-TOKEN'] = localStorage.getItem("csrf_token");
  // config.headers['Cookie'] = csrfToken;

  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  
console.log("response", response)

  if(response.data?.csrf) {
    // ✅ Store in localStorage
    localStorage.setItem("csrf_token", response.data?.csrf);
    console.log("localstorage set");
  }
  
  return response;
}, function (error) {
  // if(error.response.status === 403) {
  //   localStorage.clear();
  //   window.location.pathname = "/login";
  // }

  if(window.location.pathname != "/login" && (typeof error.response=='undefined' ||  error.response.status === 403)) {
    
    localStorage.clear();
    window.location.pathname = "/login";
  }
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});

// axios.interceptors.response.use(
//   function (res) {
//     console.log("in success",res);

//     let csrfToken = Cookies.get("yii_csrf_token"); // ✅ Retrieve CSRF token from cookie
//     Cookies.set("yii_csrf_token", csrfToken ); //, { expires: 1, path: "/" }

//     //localStorage.setItem('TOKEN', res.data.message);
//     return res;
//   },
//   (err) => {
//     console.log("in error", err);

    
//     console.log("'==========================")

//     return Promise.reject(err);
//   }
// );


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
